__turbopack_context__.v({
  "backButton": "BackToPlp-module__z25AOa__backButton",
});
